// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeroBanner-eh-hero-I_ADt {
  width: 100%;
  background: -webkit-gradient(linear, left top, left bottom, from(#ffffff), to(color-mix(in srgb, var(--secondary-cielo) 50%, transparent)));
  background: linear-gradient(#ffffff 0%, color-mix(in srgb, var(--secondary-cielo) 50%, transparent));
  /* padding: 60px 0 80px 0; */
}

.HeroBanner-eh-hero__container-dy6fV {
  /* max-width: 1180px; */
  /* margin-bottom: 30px; */
  margin-top: 65px;
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  padding: 0px 0px 0px 80px;
  /* align-items: center;
  gap: 48px; */
}

.HeroBanner-eh-hero__content-IWuC6 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  text-align: left;
}

.HeroBanner-eh-hero__badge-ODYlC {
  font-size: 24px;
  font-weight: bold;
  /* letter-spacing: 1.5px; */
  color: var(--color-gradient-top);
  text-transform: uppercase;
  margin-bottom: 16px;
  display: inline-block;
}

.HeroBanner-eh-hero__title-uKaXJ {
  font-size: 64px;
  line-height: 1.18;
  font-weight: bold;
  color: var(--secondary-oscuro);
  margin: 0 0 20px 0;
  /* letter-spacing: -0.5px; */
}

.HeroBanner-eh-hero__highlight-Sd6Hq {
  color: var(--color-gradient-top)
}

.HeroBanner-eh-hero__description-FJ0YA {
  font-size: 32px;
  line-height: 1;
  color: var(--secondary-oscuro);
  margin: 0 0 36px 0;
  /* max-width: 480px; */
}

.HeroBanner-eh-hero__actions-kLu0j {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 24px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.HeroBanner-eh-hero__btn-O2Gbf {
  background: var(--color-gradient-top);
  color: #ffffff;
  font-size: 32px;
  font-weight: bold;
  padding: 14px 28px;
  border-radius: 30px;
  border: none;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -webkit-box-shadow: 0 4px 14px rgba(0, 158, 255, 0.25);
          box-shadow: 0 4px 14px rgba(0, 158, 255, 0.25);
}

.HeroBanner-eh-hero__btn-O2Gbf:hover {
  background: var(--color-gradient-top);
  -webkit-transform: translateY(-1px);
      -ms-transform: translateY(-1px);
          transform: translateY(-1px);
  -webkit-box-shadow: 0 6px 18px rgba(0, 158, 255, 0.35);
          box-shadow: 0 6px 18px rgba(0, 158, 255, 0.35);
}

.HeroBanner-eh-hero__link-more-b4GLZ {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 15px;
  font-size: 32px;
  font-weight: bold;
  color: var(--color-gradient-top) !important;
  text-decoration: none;
  cursor: pointer;
  -webkit-transition: color 0.2s ease;
  transition: color 0.2s ease;
}

.HeroBanner-eh-hero__link-more-b4GLZ:hover {
  color: var(--color-gradient-top);
  text-decoration: none;
}

.HeroBanner-eh-hero__chevron-F8_HD {
  -webkit-transition: -webkit-transform 0.2s ease;
  transition: -webkit-transform 0.2s ease;
  transition: transform 0.2s ease;
  transition: transform 0.2s ease, -webkit-transform 0.2s ease;
  color: var(--color-gradient-top)
}

.HeroBanner-eh-hero__link-more-b4GLZ:hover .HeroBanner-eh-hero__chevron-F8_HD {
  -webkit-transform: translateY(2px);
      -ms-transform: translateY(2px);
          transform: translateY(2px);
}

.HeroBanner-eh-hero__media-ODtBD {
  -webkit-box-flex: 1;
      -ms-flex: 1 1;
          flex: 1 1;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  overflow: hidden;
}

.HeroBanner-eh-hero__image-wrapper-K99b_ {
  /* width: 100%;
  max-width: 520px;
  height: 600px;
  border-radius: 350px 0 0 0;
  overflow: hidden;
  box-shadow: 0 16px 36px rgba(15, 40, 71, 0.12);
  background: #f0f0f0; */
}

.HeroBanner-eh-hero__img-KzXqV {
  width: 100%;
  max-width: 48dvw;
  height: 600px;
  border-radius: 350px 0px 0px 0px;
  -o-object-fit: cover;
     object-fit: cover;
}

@media (max-width: 960px) {
  .HeroBanner-eh-hero__container-dy6fV {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  .HeroBanner-eh-hero__content-IWuC6 {
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    text-align: center;
  }
  .HeroBanner-eh-hero__title-uKaXJ {
    font-size: 36px;
  }
  .HeroBanner-eh-hero__description-FJ0YA {
    max-width: 100%;
  }
  .HeroBanner-eh-hero__image-wrapper-K99b_ {
    max-width: 440px;
    height: 480px;
  }
}

@media (max-width: 540px) {
  .HeroBanner-eh-hero-I_ADt {
    padding: 32px 16px 48px;
  }
  .HeroBanner-eh-hero__title-uKaXJ {
    font-size: 30px;
  }
  .HeroBanner-eh-hero__actions-kLu0j {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    width: 100%;
    gap: 16px;
  }
  .HeroBanner-eh-hero__btn-O2Gbf {
    width: 100%;
  }
  .HeroBanner-eh-hero__image-wrapper-K99b_ {
    height: 300px;
    border-radius: 180px 0 0 0;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/WhyhostView/HeroBanner.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,2IAAoG;EAApG,oGAAoG;EACpG,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,gCAAgC;EAChC,yBAAyB;EACzB;cACY;AACd;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,gCAAgC;EAChC,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,mBAAe;MAAf,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iCAAyB;EAAzB,yBAAyB;EACzB,sDAA8C;UAA9C,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;EAC3B,sDAA8C;UAA9C,8CAA8C;AAChD;;AAEA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,2CAA2C;EAC3C,qBAAqB;EACrB,eAAe;EACf,mCAA2B;EAA3B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,+CAA+B;EAA/B,uCAA+B;EAA/B,+BAA+B;EAA/B,4DAA+B;EAC/B;AACF;;AAEA;EACE,kCAA0B;MAA1B,8BAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,mBAAO;MAAP,aAAO;UAAP,SAAO;EACP,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;;;;;;wBAMsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,gCAAgC;EAChC,oBAAiB;KAAjB,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,aAAa;EACf;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,WAAW;IACX,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;IACb,0BAA0B;EAC5B;AACF","sourcesContent":[".eh-hero {\n  width: 100%;\n  background: linear-gradient(#ffffff 0%, color-mix(in srgb, var(--secondary-cielo) 50%, transparent));\n  /* padding: 60px 0 80px 0; */\n}\n\n.eh-hero__container {\n  /* max-width: 1180px; */\n  /* margin-bottom: 30px; */\n  margin-top: 65px;\n  display: grid;\n  grid-template-columns: 1fr 1.2fr;\n  padding: 0px 0px 0px 80px;\n  /* align-items: center;\n  gap: 48px; */\n}\n\n.eh-hero__content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-align: left;\n}\n\n.eh-hero__badge {\n  font-size: 24px;\n  font-weight: bold;\n  /* letter-spacing: 1.5px; */\n  color: var(--color-gradient-top);\n  text-transform: uppercase;\n  margin-bottom: 16px;\n  display: inline-block;\n}\n\n.eh-hero__title {\n  font-size: 64px;\n  line-height: 1.18;\n  font-weight: bold;\n  color: var(--secondary-oscuro);\n  margin: 0 0 20px 0;\n  /* letter-spacing: -0.5px; */\n}\n\n.eh-hero__highlight {\n  color: var(--color-gradient-top)\n}\n\n.eh-hero__description {\n  font-size: 32px;\n  line-height: 1;\n  color: var(--secondary-oscuro);\n  margin: 0 0 36px 0;\n  /* max-width: 480px; */\n}\n\n.eh-hero__actions {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  flex-wrap: wrap;\n}\n\n.eh-hero__btn {\n  background: var(--color-gradient-top);\n  color: #ffffff;\n  font-size: 32px;\n  font-weight: bold;\n  padding: 14px 28px;\n  border-radius: 30px;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 14px rgba(0, 158, 255, 0.25);\n}\n\n.eh-hero__btn:hover {\n  background: var(--color-gradient-top);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 18px rgba(0, 158, 255, 0.35);\n}\n\n.eh-hero__link-more {\n  display: inline-flex;\n  align-items: center;\n  gap: 15px;\n  font-size: 32px;\n  font-weight: bold;\n  color: var(--color-gradient-top) !important;\n  text-decoration: none;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.eh-hero__link-more:hover {\n  color: var(--color-gradient-top);\n  text-decoration: none;\n}\n\n.eh-hero__chevron {\n  transition: transform 0.2s ease;\n  color: var(--color-gradient-top)\n}\n\n.eh-hero__link-more:hover .eh-hero__chevron {\n  transform: translateY(2px);\n}\n\n.eh-hero__media {\n  flex: 1;\n  position: relative;\n  display: flex;\n  justify-content: flex-end;\n  overflow: hidden;\n}\n\n.eh-hero__image-wrapper {\n  /* width: 100%;\n  max-width: 520px;\n  height: 600px;\n  border-radius: 350px 0 0 0;\n  overflow: hidden;\n  box-shadow: 0 16px 36px rgba(15, 40, 71, 0.12);\n  background: #f0f0f0; */\n}\n\n.eh-hero__img {\n  width: 100%;\n  max-width: 48dvw;\n  height: 600px;\n  border-radius: 350px 0px 0px 0px;\n  object-fit: cover;\n}\n\n@media (max-width: 960px) {\n  .eh-hero__container {\n    grid-template-columns: 1fr;\n    gap: 40px;\n  }\n  .eh-hero__content {\n    align-items: center;\n    text-align: center;\n  }\n  .eh-hero__title {\n    font-size: 36px;\n  }\n  .eh-hero__description {\n    max-width: 100%;\n  }\n  .eh-hero__image-wrapper {\n    max-width: 440px;\n    height: 480px;\n  }\n}\n\n@media (max-width: 540px) {\n  .eh-hero {\n    padding: 32px 16px 48px;\n  }\n  .eh-hero__title {\n    font-size: 30px;\n  }\n  .eh-hero__actions {\n    flex-direction: column;\n    width: 100%;\n    gap: 16px;\n  }\n  .eh-hero__btn {\n    width: 100%;\n  }\n  .eh-hero__image-wrapper {\n    height: 300px;\n    border-radius: 180px 0 0 0;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"eh-hero": `HeroBanner-eh-hero-I_ADt`,
	"eh-hero__container": `HeroBanner-eh-hero__container-dy6fV`,
	"eh-hero__content": `HeroBanner-eh-hero__content-IWuC6`,
	"eh-hero__badge": `HeroBanner-eh-hero__badge-ODYlC`,
	"eh-hero__title": `HeroBanner-eh-hero__title-uKaXJ`,
	"eh-hero__highlight": `HeroBanner-eh-hero__highlight-Sd6Hq`,
	"eh-hero__description": `HeroBanner-eh-hero__description-FJ0YA`,
	"eh-hero__actions": `HeroBanner-eh-hero__actions-kLu0j`,
	"eh-hero__btn": `HeroBanner-eh-hero__btn-O2Gbf`,
	"eh-hero__link-more": `HeroBanner-eh-hero__link-more-b4GLZ`,
	"eh-hero__chevron": `HeroBanner-eh-hero__chevron-F8_HD`,
	"eh-hero__media": `HeroBanner-eh-hero__media-ODtBD`,
	"eh-hero__image-wrapper": `HeroBanner-eh-hero__image-wrapper-K99b_`,
	"eh-hero__img": `HeroBanner-eh-hero__img-KzXqV`
};
module.exports = ___CSS_LOADER_EXPORT___;
